import React, { useEffect, useState } from 'react';
import { Modal, Tooltip, Row } from 'antd';
import { Button, ColumnProps, FormContext, FormDatePicker, FormSubmitButton, MasterDetailForm, Table } from '@digital/ui';

import * as Yup from 'yup';
import { IArquivo, IArquivoActions } from '@app/types/core.types';
import { deleteDocumento, downloadArquivo, getArquivosDocumentoOrdemCompraByOc, incluirDocumento, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { useRecoilState, useRecoilValue } from 'recoil';
import { modalAcoesIdState, ordemCompraIdState, reloadVendorListState, dataLimiteEtapaState } from '../atoms';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { SimpleUpload, Visibility } from '@app/components';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import { GetFileExtension, imageFormats } from '@app/helpers';
import { responderRecebimentoPropostaTecnicasProponentes } from '@app/api/sas/sasProposta';


const ModalRecebimentoPropostaTecnica = ({ record }: any) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);

    const [exibirModal, setExibirModal] = useState(false);
    const [arquivos, setArquivos] = useState<IArquivo[]>([]);

    const loadArquivos = async () => {
        getArquivosDocumentoOrdemCompraByOc({
            ordemCompraId,
            sasTipoDocumentoId: EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes,
            sasPropostaId: record.id,
        }).then((data: any) => {
            setArquivos(data.filter((c: any) => c.status === 'Vigente') || []);
        });
    };

    useEffect(() => {
        if (exibirModal) {
            setArquivos([]);
            loadArquivos();
        }
    }, [exibirModal]);

    const arquivoActions: IArquivoActions = {
        onDownload: (arquivo: IArquivo) => {
            downloadArquivo(
                arquivo.id,
                arquivo.nome
            );
        },
        onView(arquivo: IArquivo) {
            viewArquivo(
                arquivo.id,
                arquivo.nome
            );
        },
        onDelete: (arquivo) => deleteDocumento(arquivo.sasDocumentoId, arquivo.id),
    };

    const renderTableActions = (record: IArquivo) => (
        <Row type='flex'>

            <SimpleUpload
                visible={isObjNotEmpty(arquivoActions)}
                idDoComponente="uploadSolicitacaoEnvioEsclarecimentosTecnicos"
                title={`${(isObjEmpty(record)) ? "Adicionar" : "Substituir"} Arquivo`}
                hasLabel={false}
                showUploadList={false}
                nameFormData='arquivo'
                onUploadVisible={arquivoActions && isObjNotEmpty(arquivoActions.onUpload)}
                onUpload={async (values) => arquivoActions
                    && arquivoActions.onUpload
                    && arquivoActions.onUpload({ ...record, ...values })
                        .then(() => loadArquivos())}
                onDownloadVisible={arquivoActions && isObjNotEmpty(arquivoActions.onDownload)}
                onDownload={() => arquivoActions
                    && arquivoActions.onDownload
                    && arquivoActions.onDownload(record)}
            />

            <Visibility
                visible={
                    arquivoActions && isObjNotEmpty(arquivoActions.onView)
                    && (GetFileExtension(record.nome) === "pdf" || imageFormats.includes(GetFileExtension(record.nome)))
                }
            >
                <Tooltip title="Visualizar Arquivo">
                    <Button
                        icon="files-view_file"
                        type="link"
                        onClick={() => arquivoActions && arquivoActions.onView && arquivoActions.onView(record)}
                    />
                </Tooltip>
            </Visibility>

            <Visibility
                visible={
                    arquivoActions && isObjNotEmpty(arquivoActions.onDelete)
                }
            >
                <Tooltip title="Delete Arquivo">
                    <Button
                        icon="commons-trash"
                        type="link"
                        onClick={async () => {
                            if (arquivoActions && arquivoActions.onDelete) {
                                arquivoActions.onDelete(record)
                                    .then(() => {
                                        loadArquivos();
                                    });
                            }
                        }}
                    />
                </Tooltip>
            </Visibility>
        </Row>
    );

    const columns = () => {
        let columns: ColumnProps<IArquivo>[] = [];

        columns.push({
            title: 'Arquivo',
            dataIndex: 'nome',
            // width: '40%'
        });

        columns.push({
            title: 'Status',
            className: "td-centralizado",
            dataIndex: 'status',
            width: '15%'
        });

        columns.push({
            title: 'Versão',
            className: "td-centralizado",
            dataIndex: 'versao',
            width: '10%'
        });

        columns.push({
            title: 'Ações',
            dataIndex: '',
            width: '15%',
            render(text, record, index) {
                return renderTableActions(record);
            },
        });


        return columns;
    };

    const aceitarRecebimentoPropostaTecnicasProponentes = (values: any) => {
        const form = new FormData();

        form.append('SasPropostaId', record.id);
        form.append('data', values.dataStatusPropostaTecnica);
        form.append('resposta', 'true');

        return responderRecebimentoPropostaTecnicasProponentes(form)
            .then((data: any) => {
                if (data && data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    setExibirModal(false);
                    setModalAcoesId('');
                } else {
                    if (data.days) {
                        Modal.confirm({
                            title: 'Data fora do prazo',
                            content: `A data de recebimento informada está fora do prazo definido. Está ${data.days < 0 ? `${data.days * -1} dia(s) adiantado(s)` : `${data.days} dia(s) atrasado(s)`} . Confirma que esta data está correta?`,
                            cancelText: 'Não',
                            onCancel: () => {

                            },
                            okText: 'Sim',
                            onOk: () => {
                                form.append('ignoraData', 'true');
                                responderRecebimentoPropostaTecnicasProponentes(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            setReloadVendorList(!reloadVendorList);
                                            setExibirModal(false);
                                            setModalAcoesId('');
                                        }
                                    });
                            },
                        });
                    }
                }
            });
    };

    return (
        <>
            <Tooltip title="Recebimento Proposta Técnica">
                <Button
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    icon={"ui-upload"}
                >
                </Button>
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title={"Recebimento Proposta Técnica"}
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <MasterDetailForm
                        initialValues={record}
                        onSubmit={aceitarRecebimentoPropostaTecnicasProponentes}
                        validationSchema={Yup.object().shape({
                            dataStatusPropostaTecnica: Yup.string().required('A data deve ser informada')
                        })}
                        actions={[
                            <Button
                                type='link'
                                onClick={() => {
                                    setExibirModal(false);
                                }}
                                title='Fechar'
                            />,
                            <FormSubmitButton noIcon type="primary" title='Salvar' />
                        ]}
                    >
                        <FormContext.Consumer>
                            {({ formProps }) =>

                            (<>
                                <FormDatePicker
                                    format="DD/MM/YYYY"
                                    label='Data'
                                    name="dataStatusPropostaTecnica"
                                    span={3}
                                    disabledDate={function(current) {
                                        if (!dataLimiteEtapa) return false;
                                        var limite = new Date(dataLimiteEtapa);
                                        limite.setHours(23, 59, 59, 999);
                                        return current && current.toDate() > limite;
                                    }}
                                />

                                <SimpleUpload
                                    visible={exibirModal}
                                    nameFormData={'arquivo'}
                                    label={'Adicionar Arquivo'}
                                    hasFile={false}
                                    type="primary"
                                    idDoComponente="sgc-upload-UploadModalHistorico"
                                    key="formUploadModalHistorico"
                                    onUpload={(values) => {
                                        if (formProps) {
                                            incluirDocumento({
                                                ordemCompraId: ordemCompraId,
                                                sasTipoDocumentoId: EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes,
                                                descricao: 'Proposta Técnica',
                                                sasPropostaId: record.id,
                                                files: values.arquivo,
                                                multiple: true,
                                                documentoId: arquivos.length > 0 ? arquivos[0].sasDocumentoId : undefined
                                            }).then(() => {
                                                loadArquivos();
                                            });
                                        }
                                    }}
                                    onDownloadVisible={false}
                                    showUploadList={false}
                                    multiple
                                />

                                <Table
                                    dataSource={arquivos}
                                    columns={columns()}
                                    rowKey="id"
                                    pagination={arquivos.length > 10 ? { pageSize: 10 } : false}
                                />
                            </>
                            )}
                        </FormContext.Consumer>
                    </MasterDetailForm>


                </Modal>
            </Visibility>
        </>
    );
};

export default ModalRecebimentoPropostaTecnica;